<div class="panel panel-form" [ngClass]="{ open: open }">
  <lib-form-header [open]="open" [header]="header" [required]="required" (openChange)="open = $event"></lib-form-header>
  @if (open && form) {
    <div class="panel-content">
      @if (taxes.length > 0) {
        <form [formGroup]="form">
          @for (price of getPrices().controls; track price; let i = $index) {
            <div class="row">
              <div class="col-12 mt-2">
                <form [formGroup]="$any(price)">
                  <div class="row" [ngClass]="{ inactive: isPriceInactive(price) }">
                    <div class="col-10 col-sm-11 order-2 order-md-1">
                      <div class="row">
                        @for (key of priceOrder; track key) {
                          <div class="form-field-container col-12 col-sm-6 col-md-3">
                            @if (i < 1) {
                              <div class="form-field-label" [ngClass]="{ required: key !== 'name' }">
                                {{ 'form.field.' + key | transloco }}
                                @if (key === 'available_from') {
                                  <div
                                    class="i-icon"
                                    #tooltip="matTooltip"
                                    [matTooltip]="'tooltip.product.price_' + key | transloco"
                                    [matTooltipPosition]="'above'"
                                    (click)="tooltip.toggle()"
                                  >
                                    <span class="i">i</span>
                                  </div>
                                }
                              </div>
                            }
                            @if (key === 'name') {
                              <mat-form-field class="form-field" [floatLabel]="'auto'">
                                <input matInput [formControlName]="key" [readonly]="isPriceInactive(price)" />
                                @if (price.get(key).invalid) {
                                  <mat-error>
                                    @if (price.get(key).errors.required) {
                                      {{ 'form.error.required' | transloco }}
                                    }
                                  </mat-error>
                                }
                              </mat-form-field>
                            }
                            @if (key === 'amount') {
                              <mat-form-field class="form-field form-field-currency" [floatLabel]="'auto'">
                                <input
                                  matInput
                                  currencyMask
                                  [formControlName]="key"
                                  [options]="{ align: 'left', prefix: '', thousands: '.', decimal: ',' }"
                                  [readonly]="isPriceInactive(price | formGroup)"
                                />
                                <span class="currency">€</span>
                                @if (price.get(key).invalid) {
                                  <mat-error>
                                    @if (price.get(key).errors.required) {
                                      {{ 'form.error.required' | transloco }}
                                    }
                                  </mat-error>
                                }
                              </mat-form-field>
                            }
                            @if (key === 'tax_id') {
                              <lib-select
                                [options]="taxes"
                                [value]="price.get(key).value"
                                [errors]="price.get(key).errors"
                                (valueChange)="price.get(key).setValue($event)"
                              ></lib-select>
                            }
                            @if (key === 'available_from') {
                              <lib-date-time-field [formControlName]="key" readonly>
                                @if (price.get(key).invalid) {
                                  <mat-error>
                                    @if (price.get(key).errors.required) {
                                      {{ 'form.error.required' | transloco }}
                                    }
                                    @if (price.get(key).errors.price_date_after_product_start) {
                                      Price start date is set after product start date
                                    }
                                  </mat-error>
                                }
                              </lib-date-time-field>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-2 col-sm-1 col-option-remove text-right order-1 order-md-2">
                      <button
                        class="btn btn-remove mt-2"
                        [ngClass]="{ 'v-hidden': i === 0 || isPriceInactive(price) }"
                        (click)="removePrice(i)"
                      >
                        <span class="icon-remove d-block" [inlineSVG]="'/icons/icon-close.svg'"></span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }
          <div class="row mt-2">
            <div class="col-12 col-sm-auto">
              <button class="btn btn-secondary d-block w-100" (click)="addPrice()">
                {{ 'product.add_price' | transloco }}
              </button>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-12 col-sm-4 form-field-container">
              <div class="form-field-label">
                {{ 'form.field.regular_amount' | transloco }}
                <div
                  class="i-icon"
                  #tooltip="matTooltip"
                  [matTooltip]="'tooltip.product.price_regular_amount' | transloco"
                  [matTooltipPosition]="'above'"
                  (click)="tooltip.toggle()"
                >
                  <span class="i">i</span>
                </div>
              </div>
              <mat-form-field class="form-field form-field-currency" [floatLabel]="'auto'">
                <span class="currency">€</span>
                <input
                  matInput
                  currencyMask
                  [formControlName]="'regular_amount'"
                  [options]="{ align: 'left', prefix: '', thousands: '.', decimal: ',' }"
                />
              </mat-form-field>
            </div>
          </div>
        </form>
      }
    </div>
  }
</div>
